import axios from 'axios'
import Globals from './Globals'

export function getContentPath(path, fromCore){

    // console.log('getContentPath', Globals.instance().useLocal, localStorage.getItem('offlineMode') , Globals.instance().offlineMode, path, fromCore)

    if(!path) {console.warn("empty path sent"); return "" }
    if( path.indexOf('http')===0)return path

    if(!fromCore && (Globals.instance().electron || Globals.instance().ios)){
        
        let downloadPath;
        
        // if(Globals.instance().nid && (downloadedArray.findIndex(a =>parseInt(a.id) === Globals.instance().nid) > -1)) {
            if (Globals.instance().nid && Globals.instance().useLocal) {
            
        
            if (Globals.instance().electron) {
                downloadPath = `${Globals.instance().appPath}/${Globals.instance().nid}/${path}`;
            }

            if (Globals.instance().ios) {
                downloadPath = `${Globals.instance().nid}/${path}`;
            }
            // console.log('getContentPath', downloadPath, Globals.instance().appPath)

            return downloadPath
        } 

        if (Globals.instance().ios && Globals.instance().controllerApp && Globals.instance().nid) {
            downloadPath = `${Globals.instance().nid}/${path}`;
            return downloadPath;
        }
        
        
    } 
    let contentPath = Globals.instance().contentpath;

    if ((localStorage.getItem('offlineMode') === 'true' || Globals.instance().offlineMode) && (Globals.instance().electron || Globals.instance().ios)) {
        if (Globals.instance().electron) {
            contentPath = `${Globals.instance().appPath}/media/`;
        }
        // if (Globals.instance().ios) {
        //     contentPath = `content/`;
        // }
        // contentPath = Globals.instance().localContentPath;
         console.log('getContentPath result', contentPath, contentPath + path)
    }
   
   

    return contentPath + path;

}


export function getCMSPath(path, fromCore){

    // console.log('getCMSPath', Globals.instance().useLocal, path, fromCore)

    if(((Globals.instance().electron || Globals.instance().ios) && Globals.instance().useLocal) || (Globals.instance().ios && Globals.instance().controllerApp)){
        let tokenParams;
        let p=path;
        if( path.indexOf('http')===0){
            let i=path.indexOf('/api/')
            p=path.slice(i+5) 
        }    
        if(p.slice(-12)==="?format=json")p=p.slice(0,-12)
        if(p.slice(-1)==='/') p=p.slice(0,-1)
        if(p.slice(-5)!=='.json')p=p+'.json'
        
        let p0 = p.replace('-opt','')
        p = p0.replace('-pages','')
        let downloadPath;
        let downloadedArray = [];
        let downloadCookie = localStorage.getItem('expo.downloaded')
        if (downloadCookie) {
            downloadedArray = JSON.parse(downloadCookie)
        }
        // console.log('getCMSPath', downloadedArray)

        // console.log("downloadedArray", downloadedArray, parseInt(Globals.instance().nid), Globals.instance().controllerApp)

        if (Globals.instance().electron && Globals.instance().useLocal) {
            downloadPath = `${Globals.instance().appPath}/${Globals.instance().nid}/${p}`;
        } else {
            downloadPath = `${Globals.instance().nid}/${p}`;
        }

        // TESTING
        if (!Globals.instance().nid) {
            downloadPath = `./api/${p}`;
            console.log("DOWNLOAD PATH CONTROLLER", downloadPath)
        }

        if (Globals.instance().ios && Globals.instance().controllerApp && Globals.instance().nid) {
            downloadPath = `${Globals.instance().nid}/${p}`;
            console.log("DOWNLOAD PATH Controller with NID", downloadPath, Globals.instance().nid, p)
        }

        
        console.log("DOWNLOAD PATH", downloadPath, Globals.instance().appPath, Globals.instance().nid)
        
        // console.log("return nid version")
        console.log("returning cms path 0", downloadPath, Globals.instance().appPath, Globals.instance().nid)
        
        return downloadPath

    }

    let apiPath = Globals.instance().cmspath;
    // if (Globals.instance().controllerApp) {
    //     apiPath = this.adminAPI + "/api/"
    // }


    // Not sure where this is getting dropped so added this workaround for now.
    if (!Globals.instance().cmspath.includes('/api/')) {
        apiPath = Globals.instance().cmspath + "/api/"
    }
            
    if( path.indexOf('http')===0)return path //hard coded path goes there no matter what

    // console.log(Globals.instance().cmspath +path)
    console.log("returning cms path 1", apiPath + path)
    
    return apiPath + path;
}

export async function fetchCMSJSONs(arr,cancelToken){
    return new Promise((resolve,reject)=>{
    let arrPromises = []
        arr.forEach(val=>{ arrPromises.push(fetchCMSJSON(val,cancelToken))})
        Promise.all(arrPromises).then(values=>{  resolve(values) }).catch( error =>{
            reject(error)
        })
    })
}
export async function fetchCMSJSON(path,cancelToken,fromCore,tempToken){
    let token;
    let headers;

    console.log('fetchCMSJSON', getCMSPath(path,fromCore))
    
    let userObj;
    let strUser = localStorage.getItem('user')
    
    if (strUser) {
        userObj = JSON.parse(strUser)
        token = userObj['token']
    }

    if (token) {
        headers = {
            Authorization: 'Token ' + token
          }
    } else {
        headers = {}
    }

    
    return new Promise( (resolve,reject) => {
        axios({
            method: "get",
            url: getCMSPath(path, fromCore),
            headers: headers,
            }).then(response=>{
            console.log('getCMSPath res', response.data, getCMSPath(path,fromCore))

            // TEMP WORKAROUND: NEED THIS FOR RECEIVE MODE
            if (!userObj) {
                console.log('!userObj')
                setTimeout(() => {
                    resolve(response.data)      
                }, 500);
            } else {
                resolve(response.data) 
            }
            
            
    
        })
        .catch(error=>{
            console.warn('could not fetch json', getCMSPath(path,fromCore))
            reject({error,path})
        })
    })
}

export async function loadContentFile(src){ 
    return new Promise( (resolve,reject) => {
        axios.get(getContentPath(src)).then(response=>{
            resolve(response.data)
        })
        .catch(error=>{
            console.warn('loadContentFile: could not fetch json',src)
            reject({error,src})
        })
    })
}

export async function loadImage(src){ return new Promise( resolve=>{
    let img = new Image() 
    img.src=src
    img.onload=()=>{resolve(img)}
    img.onError=()=>{console.error('Error loading image '+src)}
})}

export async function fetchThemes(cancelToken){ return fetchCMSJSON('core/theme'+(Globals.instance().usecms?'/':'.json'),cancelToken)}

export async function fetchNarratives(){ 
    let path;
    let objs = [];
    let offlineMode = localStorage.getItem('offlineMode');
    console.log('offlineMode', offlineMode, Globals.instance().offlineMode)
    if ((offlineMode === 'true' || Globals.instance().offlineMode) && (Globals.instance().electron || (Globals.instance().ios && !Globals.instance().controllerApp))) {
        const downloadedStr = localStorage.getItem('expo.downloaded');

        try {
            objs = JSON.parse(downloadedStr);

            // Remove duplicate IDs, keeping the one with the most recent 'modified' date
            // This is a fix for an issue where multiple versions of the same narrative
            // were being stored in localStorage due to repeated downloads. 
            // Need to find how this is happening in the first place.
            const uniqueObjs = [];
            const seenIds = new Map();
            
            objs.forEach(obj => {
                if (!obj.id) {
                    uniqueObjs.push(obj);
                    return;
                }
                const existingObj = seenIds.get(obj.id);
                if (!existingObj) {
                    seenIds.set(obj.id, obj);
                    uniqueObjs.push(obj);
                } else {
                    // Compare modified dates - keep the more recent one
                    const currentModified = new Date(obj.modified || 0);
                    const existingModified = new Date(existingObj.modified || 0);
                    
                    if (currentModified > existingModified) {
                        // Replace the existing object with the newer one
                        const existingIndex = uniqueObjs.findIndex(item => item.id === obj.id);
                        if (existingIndex !== -1) {
                            uniqueObjs[existingIndex] = obj;
                            seenIds.set(obj.id, obj);
                        }
                    }
                    // If existing is newer or same, do nothing (keep existing)
                }
            });
            
            objs = uniqueObjs;
            
        } catch (e) {
            console.error("Invalid JSON in expo.downloaded", e);
            path = null;
        }
        return objs;
    } else {
        path = 'core/narratives' + (Globals.instance().usecms ? '/' : '.json');
        return fetchCMSJSON(path);
    }

    
}
// export async function fetchNarrativeGroups(){ return fetchCMSJSON('core/narrative-group'+(Globals.instance().usecms?'/':'.json'))}

export async function fetchNarrativeGroups(){ return [] }

export function onErrorLoad(err){
    //save this somehow?
    // console.error(err)
    // window.dispatchEvent(new CustomEvent('alert',{details:err.toString}))
    
}